import axios from "axios";

import { IDefaultInputInstruction } from "../../../pages/ConfiguracaoSimulador/interfaces";

import { urlHttpGov } from "../../urls";
import { getToken } from "../../LStorage/token";

class DefaultInputInstructionService {
  private readonly baseURL = `${urlHttpGov}/simulador-inteligente/instrucao-padrao`;

  async create(message: Omit<IDefaultInputInstruction, "_id">): Promise<IDefaultInputInstruction> {
    const { data } = await axios.post(this.baseURL, message, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    });

    return data;
  }

  async update(message: IDefaultInputInstruction): Promise<IDefaultInputInstruction> {
    const { data } = await axios.put(this.baseURL, message, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    });

    return data;
  }

  async get(signal: AbortSignal): Promise<IDefaultInputInstruction[]> {
    const { data } = await axios.get(this.baseURL, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      },
      signal
    });

    return data;
  }
}

export default new DefaultInputInstructionService();
